import { connect } from 'react-redux';
import { ISpeechVoiceSelectEvents, ISpeechVoiceSelectFields } from '../components/types';
import { SpeechVoiceSelect } from '../components/SpeechVoiceSelect';
import { IState } from '../../../store/types';
import { SpeechVoiceManager, SpeechVoiceUserSelector } from '../../../effects/speechVoiceManager';
import { SpeechVoiceSelectEvents } from './events';
import { getSpeechLangVoiceMap } from '../../../store/general/selectors';
import { hocPropsCache, IHocPropsCacheStore } from '../../../types/common';

const mapStateToProps = () => {
	const cacheStore: IHocPropsCacheStore<ISpeechVoiceSelectFields> = {}

	return (
		state: IState
	): ISpeechVoiceSelectFields => {

		const voicesMap = SpeechVoiceManager.getVoices();
		const userVoicesMap = getSpeechLangVoiceMap(state);
		const langs = SpeechVoiceUserSelector.getUserLangsForSelect();

		return hocPropsCache({
			langs,
			voicesMap,
			userVoicesMap,
		}, cacheStore);
	}
}

const mapDispatchToProps = (
	dispatch: any,
): ISpeechVoiceSelectEvents => {
	return {
		onSave: (lang, voice) => dispatch(SpeechVoiceSelectEvents.onSave(lang, voice)),
	}
};

export const SpeechVoiceSelectHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(SpeechVoiceSelect);

SpeechVoiceSelectHOC.displayName = 'SpeechVoiceSelectHOC';
